<template>
    <div class="mortgage-contract-form" id="mortgageContracts">
        <preloader v-show="loading"></preloader>

        <div v-if="sendedSuccess" class="form__scope _position-relative">
            <div class="mortgage-contract-form__bg mortgage-contract-form__bg_final _mobile-hidden"></div>
            <div class="_dflex _flexwrap">
                <div class="_w-480-full">
                    <div class="h2 _mb-16-8">
                        Заявка успешно отправлена
                    </div>
                </div>
            </div>
        </div>

        <div v-if="isError" class="form__scope _position-relative">
            <div class="mortgage-contract-form__bg mortgage-contract-form__bg_final _mobile-hidden"></div>
            <div class="_dflex _flexwrap">
                <div class="h2 _mb-16-8">
                    Произошла ошибка. Пожалуйста, повторите попытку позже
                </div>
            </div>
        </div>

        <div v-if="!sendedSuccess && !isError" class="form__scope">
            <h1 class="h2">Передача сведений о предмете ипотеки</h1>
            <template>
                <div class="_pt-0 _pb-0 _mt-24">
                    <div class="_w-100">
                        <div class="form__row">
                            <div class="form__col">
                                <div class="form__input">
                                    <input
                                        v-model.trim.lazy="$v.contactDetails.fullName.surname.$model"
                                        :class="{ '_invalid': $v.contactDetails.fullName.surname.$error, '_focus': contactDetails.fullName.surname.length > 0 }"
                                        type="text"
                                        class="d-input"
                                        name="surname"
                                        id="surname"
                                        @blur="$v.contactDetails.fullName.surname.$model = $event.target.value.trim()"
                                    >
                                    <label for="surname" class="form__label">Фамилия</label>
                                </div>
                                <p class="form-error" v-if="$v.contactDetails.fullName.surname.$error && !$v.contactDetails.fullName.surname.required">Это поле необходимо заполнить</p>
                                <p class="form-error" v-if="$v.contactDetails.fullName.surname.$error && !$v.contactDetails.fullName.surname.cyrWithDash">Поле не&nbsp;должно содержать латинские буквы</p>
                            </div>
                            <div class="form__col">
                                <div class="form__input">
                                    <input
                                        v-model.trim.lazy="$v.contactDetails.fullName.name.$model"
                                        :class="{ '_invalid': $v.contactDetails.fullName.name.$error, '_focus': contactDetails.fullName.name.length > 0 }"
                                        type="text"
                                        class="d-input"
                                        name="name"
                                        id="name"
                                        @blur="$v.contactDetails.fullName.name.$model = $event.target.value.trim()"
                                    >
                                    <label for="name" class="form__label">Имя</label>
                                </div>
                                <p class="form-error" v-if="$v.contactDetails.fullName.name.$error && !$v.contactDetails.fullName.name.required">Это поле необходимо заполнить</p>
                                <p class="form-error" v-if="$v.contactDetails.fullName.name.$error && !$v.contactDetails.fullName.name.cyrWithDash">Поле не&nbsp;должно содержать латинские буквы</p>
                            </div>
                        </div>
                        <div class="form__row">
                            <div class="form__col">
                                <div class="form__input" :class="{ 'form__input-blocked': isNoPatronymic }">
                                    <input
                                        v-model.trim.lazy="$v.contactDetails.fullName.patronymic.$model"
                                        :class="{ '_invalid': $v.contactDetails.fullName.patronymic.$error, '_focus': contactDetails.fullName.patronymic.length > 0 }"
                                        type="text"
                                        class="d-input"
                                        name="patronymic"
                                        id="patronymic"
                                        @blur="$v.contactDetails.fullName.patronymic.$model = $event.target.value.trim()"
                                    >
                                    <label for="patronymic" class="form__label">Отчество</label>
                                </div>
                                <p class="form-error" v-if="$v.contactDetails.fullName.patronymic.$error && !$v.contactDetails.fullName.patronymic.required">Это поле необходимо заполнить</p>
                                <p class="form-error" v-if="$v.contactDetails.fullName.patronymic.$error && !$v.contactDetails.fullName.patronymic.cyrWithDash">Поле не&nbsp;должно содержать латинские буквы</p>
                            </div>
                            <div class="form__col">
                                <div class="checkbox _mt-16-0 _mb-0" @click="isNoPatronymic = !isNoPatronymic">
                                    <input v-model="isNoPatronymic" type="checkbox" class="checkbox__input" name="is-no-patronymic">
                                    <label for="is-no-patronymic" class="checkbox__label">
                                        <p class="p2">Нет отчества</p>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="form__row">
                            <div class="form__col">
                                <div
                                    class="form__input"
                                >
                                    <input
                                        v-model="contactDetails.phone"
                                        v-phone
                                        v-mask="'+7 ###-###-##-##'"
                                        placeholder="+7"
                                        :class="{ '_invalid': $v.contactDetails.phone.$error, '_focus': contactDetails.phone.length > 0 }"
                                        type="tel"
                                        class="d-input _focus-always"
                                        name="phone"
                                    >
                                    <label class="form__label">Телефон</label>
                                </div>
                                <p class="form-error" v-if="$v.contactDetails.phone.$error && !$v.contactDetails.phone.required">Поле обязательно для заполнения</p>
                                <p class="form-error" v-else-if="$v.contactDetails.phone.$error && !$v.contactDetails.phone.phoneLength || !$v.contactDetails.phone.seemsDigitInPhone">Проверьте корректность номера.</p>
                            </div>
                            <div class="form__col">
                                <div class="form__input">
                                    <input
                                        v-model.trim.lazy="$v.documentNumber.$model"
                                        :class="{ '_invalid': $v.documentNumber.$error, '_focus': documentNumber.length > 0 }"
                                        type="text"
                                        class="d-input"
                                        name="document-number"
                                        @blur="$v.documentNumber.$model = $event.target.value.trim()"
                                    >
                                    <label for="document-number" class="form__label">
                                        Номер кредитного договора
                                    </label>
                                </div>
                                <p class="form-error" v-if="$v.documentNumber.$error && !$v.documentNumber.required">Поле обязательно для заполнения</p>
                                <p class="form-error" v-else-if="$v.documentNumber.$error && !$v.documentNumber.validDocnumber">Недопустимые символы</p>
                            </div>
                        </div>

                        <div class="form__row">
                            <div class="form__col _w-100">
                                <div class="form__input">
                                    <input
                                        v-model.trim.lazy="$v.cadastralNumber.$model"
                                        :class="{ '_invalid': $v.cadastralNumber.$error, '_focus': cadastralNumber.length > 0 }"
                                        type="text"
                                        class="d-input"
                                        name="document-number"
                                        v-mask="'###############'"

                                        @blur="$v.cadastralNumber.$model = $event.target.value.trim()"
                                    >
                                    <label for="document-number" class="form__label">
                                        Кадастровый номер объекта
                                    </label>
                                </div>
                                <p class="form-error" v-if="$v.cadastralNumber.$error && !$v.cadastralNumber.required">Поле обязательно для заполнения</p>
                                <p class="form-error" v-if="$v.cadastralNumber.$error && !$v.cadastralNumber.minLength">Поле некорректно заполнено</p>
                            </div>
                        </div>
                        <div class="form__row">
                            <div class="form__col _w-100">
                                <ui-form-field
                                    label="Адрес объекта"
                                    :value="objectAddress"
                                    id="document-city"
                                >
                                    <template v-slot:default="{ errors }">
                                        <UiTextInputSuggestions
                                            v-model="objectAddress"
                                            :suggestionType="ESuggestionTypes.ADDRESS"
                                            :bounds_from="EAddressBounds.CITY"
                                            :bounds_to="EAddressBounds.SETTLEMENT"
                                            :count="3"
                                            :error="!!errors.length"
                                            name="document-city"
                                        />
                                    </template>
                                </ui-form-field>
                            </div>
                        </div>
                        <div class="p1 _mb-8 _mt-32">Выписка из ЕГРН (при наличии)</div>
                        <form-docs-group
                            v-model="files"
                            category="egrn"
                            :files-max-count="5"
                            :allow-formats="['pdf', 'sig', 'png', 'jpeg', 'jpg']"
                            :fileMaxSize="1536e4"
                        >
                            <template #placeholder="{ extentions, size}">
                                {{ `Файлы формата ${extentions} размером до ${size}` }}
                            </template>
                        </form-docs-group>

                        <div class="_mt-24">
                            <div class="_dflex _flexwrap">
                                <div class="button button_green _order-second _mb-0-16" @click="onNext">Отправить</div>
                            </div>
                            <div class="form__lock _mt-24-24">
                                <span class="ico ico-safety ico_color_gray-dark ico_size_16 _mr-12"></span>
                                <span class="p4 form__lock-text">Мы защищаем ваши персональные данные, не раскрываем их третьим лицам и не распространяем без вашего согласия на это, если иное не предусмотрено законодательством</span>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

        </div>

        <!-- modals -->
        <modal-with-yandex-captcha
            :requested="modalSmsShow"
            :phone="contactDetails.phone"
            endpoint="mortgageContractsForm"
            @closeCaptchaSms="modalSmsShow = false"
            @smsConfirmed="sendForm"
        />
    </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
import { cyrWithDash, phoneLength, seemsDigitInPhone, validDocnumber } from '../../assets/js/vue/validations';
import axios from 'axios';
import { ESuggestionTypes } from '../../assets/js/vue/utlis/useDadata/utils/ESuggestionTypes';
import { EAddressBounds } from '../../assets/js/vue/utlis/useDadata/utils/EAddressBounds';
import UiTextInputSuggestions from '../../components-manual/ui/UiTextInputSuggestions.vue';
import { getSessid, scrollToElem } from '../../assets/js/utils'

export default {
    name: 'MortgageContractsForm',
    components: {
        UiTextInputSuggestions,
    },
    props: {
        url: {
            type: String,
            default: "/rest/v1/universal-form",
        },
    },
    mixins: [validationMixin],
    data() {
        return {
            contactDetails: {
                fullName: {
                    name: '',
                    surname: '',
                    patronymic: '',
                },
                phone: '',
            },
            isNoPatronymic: false,
            loading: false,
            documentNumber: '',
            cadastralNumber: '',
            objectAddress: '',
            files: [],
            sendedSuccess: false,
            isError: false,
            modalSmsShow: false,
            ESuggestionTypes,
            EAddressBounds,
            sessid: window.config.bitrix_sessid
        }
    },
    validations() {
        return {
            contactDetails: {
                fullName: {
                    name: { required, cyrWithDash, },
                    surname: { required, cyrWithDash, },
                    patronymic: {
                        required: this.isNoPatronymic ? () => true : required,
                        cyrWithDash,
                    },
                },
                phone: {
                    required,
                    phoneLength,
                    seemsDigitInPhone,
                },
            },
            documentNumber: {
                required,
                validDocnumber,
            },
            cadastralNumber: {
                required,
                minLength: minLength(14)
            },
        };
    },
    computed: {
        formData() {
            return {
                data: {
                    type: 'mortgageContractsForm',
                    attributes: {
                        fio: `${this.contactDetails.fullName.surname} ${this.contactDetails.fullName.name} ${this.contactDetails.fullName.patronymic}`,
                        agreement: true,
                        phone: this.contactDetails.phone.replace(/[\s-()\+]/g, ''), // eslint-disable-line
                        loanNumber: this.documentNumber,
                        cadastralNumber: this.cadastralNumber,
                        objectAddress: this.objectAddress,
                        documents: this.files
                    }
                },
            };
        },
    },
    methods: {
        async sendForm() {
            this.loading = true;

            return axios.post(`${this.$props.url}?sessid=${this.sessid}`, this.formData)
                .then(() => {
                    this.sendedSuccess = true;
                })
                .catch(res => {
                    if (res.response.status === 429) {
                        this.$modal.show('tooManyRequests');
                    }
                    if (res.response.status === 419) {
                        getSessid()
                            .then(res => {
                                this.sessid = res.data;
                                this.sendForm();
                            })
                    } else {
                        this.isError = true;
                    }
                })
                .finally(() => {
                    this.loading = false;
                    scrollToElem('mortgageContracts');
                });
        },
        getFormDataFiles() {
            this.files = this.files.map((val) => {
                return { type: "file", name: val.name, content: val.base64 }
            });
        },
        onNext() {
            this.$v.$touch();

            if (!this.$v.$invalid) {
                this.getFormDataFiles();
                this.modalSmsShow = true;
            }
        }
    },
}
</script>
<style lang="scss">
@import "/local/templates/redesign/src/assets/scss/base/_variables.scss";
@import "/local/templates/redesign/src/assets/scss/base/_functions.scss";
@import "/local/templates/redesign/src/assets/scss/base/_mixins.scss";

.mortgage-bond-form {
    &__bg {
        position: absolute;
        pointer-events: none;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        &_final {
            @include fluid('--width', 486px);
            @include fluid('--height', 339px);

            background: top right / var(--width) var(--height) no-repeat url('/local/templates/redesign/src/assets/img/mortgage/bond/final-banner.png');
        }
    }
}
</style>
